import { FC, useEffect } from 'react';

import { countercyclicalASCII } from '@/utilities';

const ASCIArt: FC = (): JSX.Element => {
    const currentYear = new Date().getFullYear();

    // - DevTools Easter Egg
    useEffect(() => {
        console.log(
            `${countercyclicalASCII}\n\nThank you for allocating your attention with us - WL\n\n\nCopyright © 2022 - ${currentYear} Countercyclical. All Rights Reserved.\n\n\n`,
        );
    }, []);

    return <></>;
};

export default ASCIArt;
